const rand = arr => arr[Math.floor(Math.random() * arr.length)]


const nouns = {
    chocolate: {
        word: "chocolate",
        adj: ["white", "milky", "rotten", "black"],
        tags: ["lovable", "stealable", "hatable"]
    },
    cats: {
        word: "cats",
        adj: ["black", "stray", "wild", "hairless", "cute"],
        tags: ["lovable", "stealable", "hatable"]
    },
    dogs: {
        word: "dogs",
        adj: ["big", "scary", "crazy"],
        tags: ["lovable", "stealable", "hatable", "likable"]
    },
    money: {
        word: "money",
        adj: ["dirty", "easy", "american"],
        tags: ["lovable", "stealable", "hatable"]
    },
    ball: {
        word: "ball",
        adj: ["bowling", "billiard"],
        tags: ["catchable", "rollable"]
    },
    exercises: {
        word: "exercises",
        adj: ["hard", "yoga", "military"],
        tags: ["doable", "likable"]
    },
    people: {
        word: "people",
        adj: ["evil", "happy", "irresponsible", "malicious"],
        tags: ["likable", "hatable"]
    },
    johnnydepp: {
        word: "Johnny Depp",
        adj: ["drunk", "totally hammered", "sober"],
        tags: ["likable", "hatable", "lovable"]
    },
    kirstendust: {
        word: "Kirsten Dunst",
        adj: ["drunk", "totally hammered", "sober"],
        tags: ["likable", "hatable", "lovable"]
    }
}

const nounslist = Object.keys(nouns)
// console.log(nounslist)
function chooseByTag(tag) {
    // return a list by tag
    let d = []
    for (let i of nounslist) {
        if (nouns[i].tags.includes(tag)) {
            d.push(i)
        }
    }
    let theWord = rand(d)
    console.log(theWord)

    return `${rand(nouns[theWord].adj)} ${nouns[theWord].word}`
}


const verbs = {
    do: ["do", "did", "done", "does", "doable"],
    love: ["love", "loved", "loved", "loves", "lovable"],
    steal: ["steal", "stole", "stolen", "steals", "stealable"],
    catch: ["catch", "cought", "cought", "catches", "catchable"],
    like: ["like", "liked", "liked", "likes", "likable"],
    hate: ["hate", "hated", "hated", "hates", "hatable"]
}

const adjectives = ["tired", "happy", "rich"]
const contActivities = [
    "playing football",
    "cooking dinner",
    "reading a book",
    "stealing toys from kids",
    "feeling blue",
    "doing laundry"
]

const she = ["she", "your mom", "Kirsten Dunst"]
const he = ["he", "your dad", "Johnny Depp"]
const it = ["it", "that cat", "that dog"]


// main action 
const actions = [0, 1]
// tenses
const tenses = ["present", "past", "future", "perfect"]

const subjects = [
    { word: "I", thirdPerson: true },
    { word: "you", thirdPerson: true },
    { word: "he", thirdPerson: false, options: he },
    { word: "she", thirdPerson: false, options: she },
    { word: "it", thirdPerson: false, options: it },
    { word: "they", thirdPerson: true },
    { word: "we", thirdPerson: true }
]
const mainverbs = {
    present: {
        I: ["am", "do", "'m not", "don't"],
        you: ["are", "do", "'re not", "don't"],
        he: ["is", "does", "'s not", "doesn't"],
        she: ["is", "does", "'s not", "doesn't"],
        it: ["is", "does", "'s not", "doesn't"],
        they: ["are", "do", "'re not", "don't"],
        we: ["are", "do", "'re not", "don't"]
    },
    past: {
        I: ["was", "did", "wasn't", "didn't"],
        you: ["were", "did", "weren't", "didn't"],
        he: ["was", "did", "wasn't", "didn't"],
        she: ["was", "did", "wasn't", "didn't"],
        it: ["was", "did", "wasn't", "didn't"],
        they: ["were", "did", "weren't", "didn't"],
        we: ["were", "did", "weren't", "didn't"]
    },
    future: {
        I: ["will", "will", "won't", "won't"],
        you: ["will", "will", "won't", "won't"],
        he: ["will", "will", "won't", "won't"],
        she: ["will", "will", "won't", "won't"],
        it: ["will", "will", "won't", "won't"],
        they: ["will", "will", "won't", "won't"],
        we: ["will", "will", "won't", "won't"]
    },
    perfect: {
        I: ["have", "have", "haven't", "haven't"],
        you: ["have", "have", "haven't", "haven't"],
        he: ["has", "has", "hasn't", "hasn't"],
        she: ["has", "has", "hasn't", "hasn't"],
        it: ["has", "has", "hasn't", "hasn't"],
        they: ["have", "have", "haven't", "haven't"],
        we: ["have", "have", "haven't", "haven't"]
    },

}

const verbList = Object.keys(verbs)

function makeSentence() {

    // choosing a subject and a pronoun
    const subject = rand(subjects)
    const pronoun = !subject.thirdPerson ? rand(subject.options) : subject.word


    // choosing a main action
    const action = rand(actions)
    // console.log(action === 0 ? "-----TO BE-----" : "-----TO DO-----")


    // choosing a tense and the main verb
    const tense = rand(tenses)
    // console.log(tense)
    const mainverb = mainverbs[tense][subject.word][action]

    // create a question
    let theRest = ''
    let q = ''
    let v = ''
    let secVerbObject = ''
    let be = ''
    let secVerb = ''
    if (tense === "present") {
        if (action === 0) {
            // choose an adj or continuing activity
            let words = [...adjectives, ...contActivities]
            theRest = rand(words)
            q = `${mainverb} ${pronoun} ${theRest}?`

        } else {
            // chhose a second verb
            v = rand(verbList)
            secVerbObject = verbs[v]
            secVerb = secVerbObject[0]
            theRest = chooseByTag(secVerbObject[4])
            q = `${mainverb} ${pronoun} ${secVerb} ${theRest}?`
        }
    } else if (tense === "past") {
        if (action === 0) {
            // choose an adj or continuing activity
            let words = [...adjectives, ...contActivities]
            theRest = rand(words)
            q = `${mainverb} ${pronoun} ${theRest}?`

        } else {
            // chhose a second verb
            v = rand(verbList)
            secVerbObject = verbs[v]
            secVerb = secVerbObject[0]
            theRest = chooseByTag(secVerbObject[4])
            q = `${mainverb} ${pronoun} ${secVerb} ${theRest}?`
        }
    } else if (tense === "future") {
        if (action === 0) {
            // choose an adj or continuing activity
            let words = [...adjectives, ...contActivities]
            be = 'be'
            theRest = rand(words)
            q = `${mainverb} ${pronoun} ${be} ${theRest}?`

        } else {
            // chhose a second verb
            v = rand(verbList)
            secVerbObject = verbs[v]
            secVerb = secVerbObject[0]
            theRest = chooseByTag(secVerbObject[4])
            q = `${mainverb} ${pronoun} ${secVerb} ${theRest}?`
        }
    } else {
        if (action === 0) {
            // choose an adj or continuing activity
            let words = [...adjectives, ...contActivities]
            be = 'been'
            theRest = rand(words)
            q = `${mainverb} ${pronoun} ${be} ${theRest}?`

        } else {
            // choose a second verb
            v = rand(verbList)
            secVerbObject = verbs[v]
            secVerb = secVerbObject[2]
            theRest = chooseByTag(secVerbObject[4])
            q = `${mainverb} ${pronoun} ${secVerb} ${theRest}?`
        }
    }

    // ------------------------------------create amswers------------------------------------

    function change(str) {
        if (str.startsWith('your')) {
            return str.replace('your', 'my')
        }
        if (str.startsWith('my')) {
            return str.replace('my', 'your')
        }
        if (str.startsWith('you')) {
            return str.replace('you', 'I')
        }
        if (str.startsWith('I')) {
            return str.replace('I', 'you')
        }
        if (str.startsWith('are')) {
            return str.replace('are', 'am')
        }
        if (str.startsWith('am')) {
            return str.replace('am', 'are')
        }
        if (str.startsWith("weren't")) {
            return str.replace("weren't", "wasn't")
        }
        if (str.startsWith("wasn't")) {
            return str.replace("wasn't", "weren't")
        }
        if (str.startsWith('was')) {
            return str.replace('was', 'were')
        }
        if (str.startsWith('were')) {
            return str.replace('were', 'was')
        }
        if (str.startsWith("'m")) {
            return str.replace("'m", "'re")
        }
        if (str.startsWith("'re")) {
            return str.replace("'re", "'m")
        }
        return str
    }

    // --------------------------------------------format answers--------------------------------------------
    const positiveLong = `Yes, ${change(pronoun)} ${action === 0
        ? `${subject.word === "you" || subject.word === "I" ? change(mainverb) : mainverb}${be && ' ' + be}`
        : tense === "present"
            ? !subject.thirdPerson ? `${secVerbObject[3]}` : `${secVerbObject[0]}`
            : tense === "past"
                ? `${secVerbObject[1]}`
                : tense === "perfect"
                    ? `${mainverb} ${secVerbObject[2]}`
                    : `${mainverb} ${secVerbObject[0]}`
        } ${theRest}!` // ------------
    // console.log(secVerbObject[3], '------', secVerbObject[0])
    const positiveShort = `Yes, ${subject.word === 'I' || subject.word === 'you' ? change(subject.word) : subject.word} ${subject.word === 'I' || subject.word === 'you' ? change(mainverb) : mainverb}!` // yes she is 
    // console.log('mainverb is: ----> ', mainverb)
    const dezh = subject.word === 'I' || subject.word === 'you' ? change(mainverbs[tense][subject.word][action + 2]) : mainverbs[tense][subject.word][action + 2]
    const negativeLong = `No, ${change(pronoun)}${dezh.startsWith("'") ? dezh : ' ' + dezh}${be && ' ' + be}${secVerbObject && ' ' + secVerb} ${theRest}!`
    const negativeShort = `No, ${subject.word === 'I' || subject.word === 'you' ? change(subject.word) : subject.word}${dezh.startsWith("'") ? dezh : ' ' + dezh}!` // no she isn't!



    // console.log(q)

    // console.log(positiveLong)
    // console.log(positiveShort)
    // console.log(negativeLong)
    // console.log(negativeShort)

    function toTitleCase(str) {
        let firstLetter = str.split('')[0]
        let upperCasedLetter = firstLetter.toUpperCase()
        return str.replace(firstLetter, upperCasedLetter)
    }

    return {
        q: toTitleCase(q),
        positiveLong: positiveLong,
        positiveShort: positiveShort,
        negativeLong: negativeLong,
        negativeShort: negativeShort
    }
}

export default makeSentence